/** @format */

import {addDays} from 'date-fns';

import {IsoDate, Period, PlanPeriodInput} from '../types';
import {toIso} from './toIso';

interface Options {
  plan: PlanPeriodInput;
  // Kept for call-site compatibility; the period length is a property of the plan (startOn),
  // not of when it is evaluated, so currentDate is no longer used here.
  currentDate: IsoDate;
}

// Days in the month named by a date-only ISO string, computed TZ-independently. (getDaysInMonth(
// new Date(startOn)) reads the LOCAL month off a UTC-midnight Date, so at negative offsets it
// resolves to the previous month and returns the wrong day count.)
const daysInIsoMonth = (iso: IsoDate): number => {
  const [year, month] = iso.split('-').map(Number);
  // Date.UTC month is 0-based, so passing the 1-based `month` lands on the next month; day 0 of it
  // is the last day of `month`.
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
};

// Сводит открытый/повторяющийся план к конкретному {start,end}.
export const reducePlanToPeriod = ({plan}: Options): Period => {
  const {startOn, endOn, repeat} = plan;

  let end: IsoDate;
  if (endOn) {
    end = endOn;
  } else if (repeat === 'WEEKLY') {
    end = toIso(addDays(new Date(startOn), 6));
  } else if (repeat === 'MONTHLY') {
    // Длина месячного периода привязана к месяцу startOn (свойство плана), а не к currentDate —
    // иначе длина «плавает» по мере движения даты и getPlanForDate делит на неверное число дней.
    end = toIso(addDays(new Date(startOn), daysInIsoMonth(startOn) - 1));
  } else {
    end = startOn;
  }

  return {start: startOn, end};
};
